import type {
    GetCommerceCheckoutPaymentConfigurationRequest,
    GetCommerceCheckoutPaymentConfigurationResponse,
} from "@teqtank/commerce-contracts";
import type { CommerceOperation } from "@teqtank/commerce-transport";

export const getCommerceCheckoutPaymentConfigurationOperation: CommerceOperation<
    GetCommerceCheckoutPaymentConfigurationRequest,
    GetCommerceCheckoutPaymentConfigurationResponse
> = Object.freeze({
    name: "commerce.checkout.payment.get",
});
